import React from "react";
import { useTheme } from "../context/ThemeContext";

const ThemeToggle: React.FC = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <div
            className="nav-link"
            onClick={toggleTheme}
            style={{ cursor: "pointer", display: "flex", alignItems: "center", padding: "0 10px" }}
            title={theme === "light" ? "Switch to Dark Mode" : "Switch to Light Mode"}
        >
            <i className={`mdi ${theme === "light" ? "mdi-weather-night" : "mdi-weather-sunny"}`} style={{ fontSize: "20px" }}></i>
        </div>
    );
};

export default ThemeToggle;
